<h2 mat-dialog-title class="magin_5">{{itemName}} ({{locations.length}} Locations)</h2>
<mat-dialog-content class="mat-typography">
  <div class="example-container mat-elevation-z8 magin_5">
    <table mat-table [dataSource]="locations">
      <ng-container matColumnDef="select">
        <th class="padding_10" mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" color="primary">
          </mat-checkbox>
        </th>
        <td class="padding_10" mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" color="primary">
          </mat-checkbox>
        </td>
      </ng-container>


      <!-- <ng-container matColumnDef="code">
        <th class="padding_10" mat-header-cell *matHeaderCellDef><strong> Code</strong> </th>
        <td class="padding_10" mat-cell *matCellDef="let location"><strong>{{location.Code}} </strong> </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th class="padding_10" mat-header-cell *matHeaderCellDef> <strong> Location Name </strong></th>
        <td class="padding_10" mat-cell *matCellDef="let location"> {{location.Description}} </td>
      </ng-container>

      <ng-container matColumnDef="onHand">
        <th class="padding_10" mat-header-cell *matHeaderCellDef><strong> On Hand </strong></th>
        <td class="padding_10" mat-cell *matCellDef="let location"> {{location.onHand | number:'1.0-1'}} </td>
      </ng-container>

      <ng-container matColumnDef="position">
        <th class="padding_10" mat-header-cell *matHeaderCellDef><strong> Position </strong></th>
        <td class="padding_10" mat-cell *matCellDef="let location">{{location.position | number:'1.0-1'}} </td>
      </ng-container> -->
      <!-- "Location": "100",
      "LocationDV": "Atlanta Branch100",
      "OnHandQuantity": 54938,
      "PositionQuantity": 54119 -->
      <ng-container matColumnDef="code">
        <th class="padding_10" mat-header-cell *matHeaderCellDef><strong> Code</strong> </th>
        <td class="padding_10" mat-cell *matCellDef="let location"><strong>{{location.Location}} </strong> </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th class="padding_10" mat-header-cell *matHeaderCellDef> <strong> Location Name </strong></th>
        <td class="padding_10" mat-cell *matCellDef="let location"> {{location.LocationDV}} </td>
      </ng-container>

      <ng-container matColumnDef="onHand">
        <th class="padding_10" mat-header-cell *matHeaderCellDef><strong> On Hand </strong></th>
        <td class="padding_10" mat-cell *matCellDef="let location"> {{location.OnHandQuantity | number:'1.0-1'}} </td>
      </ng-container>

      <ng-container matColumnDef="position">
        <th class="padding_10" mat-header-cell *matHeaderCellDef><strong> Position </strong></th>
        <td class="padding_10" mat-cell *matCellDef="let location">{{location.PositionQuantity | number:'1.0-1'}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div *ngIf="locations.length==0 && error == false" class="alert alert-warning text-center" role="alert">
    No quantities for this item at other locations.
  </div>
  <div *ngIf="locations.length==0 && error == true" class="alert alert-danger text-center" role="alert">
    {{errorMessage}}
  </div>
</mat-dialog-content>
<!-- <mat-dialog-actions align="end" *ngIf="isLocationSelectable == true">
  <button mat-button class="mat-mdc-button-RedBackground-WhiteText magin_5 text-white btn btn-secondary" mat-dialog-close close>Cancel</button>
  <button mat-button class="magin_5 text-white btn btn-success" (click)="saveLocation()" cdkFocusInitial>Save</button>
</mat-dialog-actions> -->
<mat-dialog-actions align="end">
  <button mat-button class="text-white" mat-dialog-close close>Close</button>
  <!-- <button mat-button class="mat-mdc-button-RedBackground-WhiteText magin_5 text-white btn"
    mat-dialog-close close>Close</button> -->
</mat-dialog-actions>
<!-- <mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button class="magin_5 text-white btn btn-success" mat-button [mat-dialog-close]="true" cdkFocusInitial>Save</button>
</mat-dialog-actions> -->